export function notificationPermissionContextKey(input: {
  installRequestedAt?: number;
  priceAlertRequestedAt?: number;
}) {
  if (input.priceAlertRequestedAt !== undefined) {
    return `price-alert:${input.priceAlertRequestedAt}`;
  }
  if (input.installRequestedAt !== undefined) return `install-return:${input.installRequestedAt}`;
  return "general";
}
